module.exports = __webpack_public_path__ + "static/media/file-minus.290d48d9.svg";